import React, { useEffect, useState } from "react";
import { Dropdown} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageElement } from "../../../components";
import { Sidebar } from "../index";

function LoginHeader() { 
  const [isActive, setActive] = useState(false);
  const [navbarHeight, setNavbarHeight] = useState();
  const [scroll, setScroll] = useState(0);
  const ToggleClass = () => {
    setActive(!isActive); 
  };
  if(isActive){
    document.querySelector('body').classList.add('openSidebar')
  }else{
    document.querySelector('body').classList.remove('openSidebar')
  }
  useEffect(() =>{
    setTimeout(() => {
        let navbar = document.querySelector(".afterloginHeader").clientHeight;
        setNavbarHeight(navbar)
        document.querySelector("body").style.paddingTop = `${navbar}px`;
        document.querySelector(".sideBar").style.top = `${navbar}px`;
        document.querySelector(".sideBar").style.height = `${window.innerHeight - navbar}px`;
      }, 300);
  })
  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck)
      }
    })
  })
  return (
    <>
        <header className={`afterloginHeader bg-white d-flex align-items-center justify-content-between ${scroll ? 'scroll' : ''}`}>
        <div className="afterloginHeader_left">
            <ul className="list-inline mb-0">
                <li className="list-inline-item">
                    <Link to="" className="sttglBtn rounded-circle" onClick={() => ToggleClass()}><em className={`${isActive ? 'gg-close' : 'gg-bar'}`}></em></Link>
                </li>
                <li className="list-inline-item">
                    <Link to="">
                        <ImageElement className="logo" source="logo.svg" alt="logo" />
                    </Link>
                </li>
            </ul>
        </div>
        <div className="afterloginHeader_right">
            <ul className="list-inline mb-0 d-flex align-items-center">
                <li className="list-inline-item">
                    <Link to="/search-service-provider" variant="primary" className="btn btn-primary d-none d-sm-flex" ><span>ask the expert</span></Link>
                </li>
                <li className="list-inline-item">
                    <div className="notifications">
                        <Dropdown align="end">
                            <Dropdown.Toggle  variant="" className="rounded-circle position-relative" id="notificationDropdown">
                                <em className="gg-notification"></em>
                                <span className="indicator"></span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <div className="dropdown-head d-flex align-items-center justify-content-between">
                                    <span className="notifications_title font-sm mb-0">Notification</span>
                                    <span className="notifications_new">25 New</span>
                                </div>
                                <ul className="dropdown-body list-unstyled mb-0">    
                                  {/* EMPTY SCREEN_______ */}
                                    {/* <li>                                      
                                        <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                            <div className="notifiPage_box_items">
                                                <div className="text-center">
                                                    <ImageElement source="notification-icon.svg" className="img-fluid notifiPage_box_icon"/>
                                                    <div className="noList_cnt">
                                                        <h5>No Notification</h5>
                                                    </div>                                
                                                </div>
                                            </div>
                                        </div>                                      
                                    </li> */}
                                    <li>
                                        <p>David has finished the job and is ready for payment. HVAC Cristy hopper kam  83928338.</p>
                                        <span><em className="gg-calendar"></em> Thu, March 3, 2022 at 8:00 AM</span>
                                    </li>
                                    <li>
                                        <p>Service Provider kam test is arrived. Cristy hopper kam 1443252269.</p>
                                        <span><em className="gg-calendar"></em> Mon, March 21, 2019 at 10:00 AM</span>
                                    </li>
                                    <li>
                                        <p>Good Guys Service Provider Smith Provider  has Accepted the service request. Cristy hopper Smith Provider  918770713907.</p>
                                        <span><em className="gg-calendar"></em> Mon, March 21, 2019 at 9:00 AM</span>
                                    </li>
                                    <li>
                                        <p>David has finished the job and is ready for payment. HVAC Cristy hopper kam  83928338.</p>
                                        <span><em className="gg-calendar"></em> Mon, March 21, 2019 at 7:15 AM</span>
                                    </li>
                                </ul>
                                <Link to="/notification" className="viewMore font-sm text-center ripple-effect">VIEW MORE</Link>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </li>
                <li className="list-inline-item">
                    <div className="userProfile">
                        <Dropdown align="end">
                            <Dropdown.Toggle  as="a" className="rounded-circle position-relative" id="profileDropdown">
                                <ImageElement className="rounded-circle" source="profile-img.png" alt="User-profile" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="border-0 rounded-0">
                                <Link className="dropdown-item" to="/profile"><em className="gg-my-profile"></em> My Profile</Link>
                                <Link className="dropdown-item" to="/change-password"><em className="gg-change-password"></em> Change Password</Link>
                                {/* <Link className="dropdown-item" to="/home"><em className="gg-sign-out"></em> Logout</Link> */}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </li>
            </ul>
        </div>
        </header>
        <Sidebar navbar={navbarHeight} />
    </>
  );
}
  
export default LoginHeader;